import { apis } from "../constants/apis";
import { getStaticConfigs } from "../helpers/common";
import axios from "../utils/axios";

export async function getDataDashboard(payload: any)
{
      const staticConfigs = await getStaticConfigs();
      const _url = staticConfigs?.REACT_APP_API_BASE_URL_CBD;
      return axios.get(`${_url}${apis.dashboard.getData}`, {
            params: { ...payload },
      });
}
